/**
 * The `features/<segment>` path segment the notification-settings routes are
 * mounted under.
 *
 * `alarm-schedules`, not `notifications`, despite living here: these routes are
 * served by `a3s-alarm-schedules`' client-api Lambda, and deployed clients call
 * them at `/api/v2/tenants/:tenantId/features/alarm-schedules/...`. Changing it
 * breaks those clients, so it needs a coordinated app and API release.
 */
export const NOTIFICATION_ROUTE_FEATURE = "alarm-schedules";
